import { QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App.tsx';
import { createConsoleQueryClient } from './api/queryClient.ts';
import { I18nProvider } from './i18n/index.ts';
import './styles.css';

/**
 * Browser entry for console-web. Vite compiles this to
 * `dist/assets/main.*.js` and `index.html` pulls it as a module. Keep
 * this file tiny — all app composition lives in `App.tsx`.
 *
 * A single `QueryClient` instance wraps the entire app; tests mount
 * their own via `<QueryClientProvider>` inside `MemoryRouter` (see
 * `test/rig.tsx`).
 */
const rootEl = document.getElementById('root');
if (rootEl === null) {
  throw new Error('console-web: #root element missing from index.html');
}

const queryClient = createConsoleQueryClient();

createRoot(rootEl).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <I18nProvider>
          <App />
        </I18nProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
